import { StyledTextFieldInput } from './StyledTextFieldInput.js';
import { styled } from 'styled-components';

export const TextFieldInputItems = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;

  & > * {
    margin-right: 8px;

    &:last-child {
      margin-left: 0;
    }
  }

  & > ${StyledTextFieldInput}:first-child {
    padding-left: 8px;
  }
`;
